// old version
export const getViewedUserSiteMemberId = (state) => state.viewedUser;
